import type { LanguageCode } from '@/lib/url-language-utils'

const LANGUAGE_LOCALES: Record<LanguageCode, string> = {
  en: 'en-US',
  zh: 'zh-CN',
  es: 'es-ES',
  fr: 'fr-FR',
  ar: 'ar-SA',
  ja: 'ja-JP',
  tw: 'zh-TW',
  ko: 'ko-KR',
}

const timeFormatters = new Map<string, Intl.DateTimeFormat>()

export function getMessageTimeLocale(language: LanguageCode): string {
  return LANGUAGE_LOCALES[language]
}

export function getMessageTimeFormatter(
  language: LanguageCode,
): Intl.DateTimeFormat {
  const locale = getMessageTimeLocale(language)
  const cached = timeFormatters.get(locale)
  if (cached)
    return cached
  const formatter = new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
  })
  timeFormatters.set(locale, formatter)
  return formatter
}

export function formatMessageTime(
  value: Date | string,
  language: LanguageCode,
): string {
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime()))
    return ''
  return getMessageTimeFormatter(language).format(date)
}
